import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import URLUtils from '../../util/URLUtils'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import SpinnerPageUI from '../common/SpinnerPageUI'

class GAuthReturnPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      response: null
    }
  }

  render() {
    if (!this.state.response)
      return (
        <SpinnerPageUI context={this.props.context} />
      )

    switch (this.state.response.statusCode) {
      case 'AuthTokenAlreadyUsed':
      case 'AuthTokenExpired':
      case 'UnknownError':
      case 'ParamatersMissing':
        return (
          <Redirect to='/pub/message?key=error' />
        )
      case 'DisconnectedAccountExists':
        return (
          <Redirect to={`/pub/link-user?provider=${this.state.response.provider}`} />
        )
      case 'LoggedInWithFBBefore':
        return (
          <Redirect to='/pub/message?key=login_with_fb' />
        )
      case 'AccessDenied':
        return (
          <Redirect to={`/pub/message?key=login_cancelled&arg=${this.state.response.provider}`} />
        )
      default:
        return (
          <Redirect to='/' />
        )
    }
  }

  /*
    http://localhost:3000/pub/gauth/return?
    state=g-1954755235&
    code=4%2FTgF4b0fR4CAJ-utNHMIdNiAPBOCsRdysDEfokmVJjZxyUVzy4FjRdyGjqauz8-A3iWSs9sUEEbte2_tHSRHJiRA&
    scope=email+profile+openid+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email+https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.profile&
    authuser=1&
    hd=moebli.com&
    session_state=5343f469d3993f407b22fbc3da65e6e246ddb897..4ec0&
    prompt=consent#
  */
  componentDidMount() {
    let params = new URLSearchParams(window.location.search)
    if (params.has('code') || params.has('error')) {
      RestApiUtils.post(this.props.context,
        '/api/pub/googleLogin',
        this.onPostCallback, {
          state: params.get('state'),
          code: params.get('code'),
          scope: params.get('scope'),
          authuser: params.get('authuser'),
          hd: params.get('hd'),
          session_state: params.get('session_state'),
          prompt: params.get('prompt'),
          error: params.get('error'),
          baseUrl: URLUtils.getBaseURL()
        }
      )
    }
  }

  onPostCallback = (response) => {
    if (response.statusCode === 'Success') { // TODO replace url
      this.props.context.onLogin(response.session, true)
      return
    }
    this.setState({response: response})
  }
}

export default GAuthReturnPageSF
